import React, { useState } from "react";
import Popup from "reactjs-popup";

export default function InfoButton({ styles = null }) {
  const [dialogVisible, setDialogVisible] = useState(true);

  const showDialog = () => {
    setDialogVisible(true);
  };

  const handleClose = () => {
    setDialogVisible(false);
  };

  return (
    <>
      <button
        style={{
          padding: "5px",
          height: "42px",
          width: "42px",
          borderRadius: "50%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          backgroundColor: "#436c9a",
          border: "none",
          cursor: "pointer",
          ...styles,
        }}
        onClick={showDialog}
      >
        <i
          style={{
            color: "white",
            fontStyle: "italic",
            fontWeight: "bold",
            fontSize: "20px",
          }}
        >
          i
        </i>
      </button>

      <Popup open={dialogVisible} onClose={handleClose} modal>
        <div
          style={{
            padding: "20px",
            maxWidth: "500px",
            backgroundColor: "white",
            borderRadius: "8px",
          }}
        >
          <div style={{ marginBottom: "15px" }}>
            <h3 style={{ margin: "0 0 10px 0" }}>Disclaimer</h3>
          </div>
          <div style={{ marginBottom: "15px" }}>
            <p style={{ margin: 0, lineHeight: "1.5" }}>
              Conditions can change rapidly, and the information on this site
              should not be considered an exact representation of current
              conditions. Street views on this website do not depict current
              conditions. Information on this site is provided "as-is," and
              RescAlert Inc. makes no guarantees or warranties of any kind
              regarding the accuracy or suitability of the information for any
              particular purpose. As a condition of using this site, the user
              specifically waives any claim against RescAlert Inc. arising from
              the use of this site.
            </p>
          </div>
          <div style={{ display: "flex", justifyContent: "flex-end" }}>
            <button
              onClick={handleClose}
              style={{
                backgroundColor: "#153d66",
                color: "white",
                border: "none",
                padding: "8px 16px",
                borderRadius: "4px",
                cursor: "pointer",
              }}
            >
              OK
            </button>
          </div>
        </div>
      </Popup>
    </>
  );
}
